    $(function() {
        const $html = $( 'html' );
        const checkScroll = () => {
            const classes   = 'scroll',
                    viewport  = 3860,
                    offset    = 65,
                    scrollTop = $( window ).scrollTop(),
                    menuOpen = $( '.submenus .submenu.active' ).length || $( '.menu[data-menu="2"][data-action!="0"]' ).length;
            if ( window.innerWidth <= viewport ) {
                if ( scrollTop > offset ) {
                    if ( $( window ).innerWidth() < 3860 ) {
                        $( "meta[name='theme-color']" ).attr( 'content', '#FEFEFE' );
                    };
                    $html.addClass( classes );
                } else {
                    if ( menuOpen ) {
                        return;
                    }
                    if ( $( window ).innerWidth() < 3860 ) {
                        $( "meta[name='theme-color']" ).attr( 'content', '#FEFEFE' );
                    };
                    $html.removeClass( classes );
                }
            }
        };
        $( window ).on( 'scroll', checkScroll );
        checkScroll();
    });

    document.querySelectorAll( 'section.shopify-section' ).forEach( el => {
        el.removeAttribute( 'id' );
        el.classList.remove( 'shopify-section' );
    });

    document.addEventListener( 'DOMContentLoaded', function() {
        var header = document.querySelector( 'header' );
        var announcements = document.querySelector( '.announcements .content .sections .section' );
        var isUpdating = false;
        function clamp( value, min, max ) {
            return Math.max( min, Math.min( max, value ) );
        }
        function setOffset() {
            if ( ! header ) {
                return;
            }
            var headerHeight = header.getBoundingClientRect().height;
            var announcementsPosition = 0;
            if ( announcements ) {
                var rect = announcements.getBoundingClientRect();
                var height = rect.height || 0;
                var visible = Math.min( rect.bottom, window.innerHeight ) - Math.max( rect.top, 0 );
                announcementsPosition = clamp( visible, 0, height );
            }
            document.documentElement.style.setProperty( '--menu', ( headerHeight + announcementsPosition ) + 'px' );
        }
        function requestSetOffset() {
            if ( isUpdating ) {
                return;
            }
            isUpdating = true;
            window.requestAnimationFrame( function() {
                setOffset();
                isUpdating = false;
            });
        }
        setOffset();
        window.addEventListener( 'scroll', requestSetOffset, { passive: true } );
        window.addEventListener( 'resize', requestSetOffset );
    });

    (function() {
        var el = $( '.submenus' );
        var submenus = el.find( '.submenu' );
        var current = '';
        var timer = null;
        var closing = false;
        var locked = false;
        var overlay = '';
        var prevent = sessionStorage.getItem( 'prevent' ) === '1';
        function unlockOnMove() {
            $( window ).one( 'mousemove', function() {
                locked = false;
            });
        }
        function clearPrevent() {
            if ( ! prevent ) {
                return;
            }
            function release() {
                prevent = false;
                sessionStorage.removeItem( 'prevent' );
                window.removeEventListener( 'mousemove', release );
                window.removeEventListener( 'pointermove', release );
            }
            window.addEventListener( 'mousemove', release, { once: true });
            window.addEventListener( 'pointermove', release, { once: true });
        }
        clearPrevent();
        function isMenuOpen() {
            return $( '.menu[data-menu="2"]' ).attr( 'data-action' ) !== '0';
        }
        function openMenu() {
            var $html = $( 'html' );
            var $icon = $( '[data-icon="1"]' );
            var $menu = $( '.menu[data-menu="2"]' );
            var timers = $menu.data( 'timers' ) || [];
            while ( timers.length ) {
                clearTimeout( timers.pop() );
            }
            $menu.off( 'transitionend.menuClose webkitTransitionEnd.menuClose' );
            $icon.attr( 'data-action', '1' );
            $menu.attr( 'data-action', '1' );
            $html.addClass( 'active' );
            timers.push( setTimeout(function() {
                $menu.attr( 'data-action', '2' );
            }, 100 ) );
            timers.push( setTimeout(function() {
                $menu.attr( 'data-action', '3' );
                if ( swiperGlobalThree ) {
                    swiperGlobalThree.update();
                    if ( swiperGlobalThree.autoplay ) {
                        swiperGlobalThree.autoplay.stop();
                        swiperGlobalThree.autoplay.start();
                    }
                }
            }, 600 ) );
            $menu.data( 'timers', timers );
        }
        function closeMenu( callback ) {
            var $html = $( 'html' );
            var $icon = $( '[data-icon="1"]' );
            var $menu = $( '.menu[data-menu="2"]' );
            var timers = $menu.data( 'timers' ) || [];
            while ( timers.length ) {
                clearTimeout( timers.pop() );
            }
            $menu.off( 'transitionend.menuClose webkitTransitionEnd.menuClose' );
            var action = $menu.attr( 'data-action' ) || '0';
            if ( action === '0' ) {
                $menu.data( 'timers', timers );
                if ( typeof callback === 'function' ) {
                    callback();
                }
                return;
            }
            $icon.attr( 'data-action', '0' );
            $menu.attr( 'data-action', '2' );
            timers.push( setTimeout(function() {
                $menu.attr( 'data-action', '1' );
            }, 100 ) );
            var done = false;
            function finishClose() {
                if ( done ) {
                    return;
                }
                done = true;
                $menu.attr( 'data-action', '0' );
                $icon.attr( 'data-action', '0' );
                $html.removeClass( 'active' );
                window.requestAnimationFrame( function() {
                    if ( swiperGlobalThree && swiperGlobalThree.autoplay ) {
                        swiperGlobalThree.autoplay.stop();
                    }
                });
                if ( typeof callback === 'function' ) {
                    callback();
                }
            }
            var fallback = setTimeout(function() {
                finishClose();
            }, 650 );
            timers.push( fallback );
            $menu.one( 'transitionend.menuClose webkitTransitionEnd.menuClose', function( e ) {
                if ( e.originalEvent && e.originalEvent.propertyName !== 'height' ) {
                    return;
                }
                clearTimeout( fallback );
                finishClose();
            });
            $menu.data( 'timers', timers );
        }
        function openSubmenu( submenu ) {
            var $submenu = $( '[data-submenu="' + submenu + '"]' );
            if ( ! $submenu.length ) {
                return;
            }
            if ( locked || prevent ) {
                return;
            }
            if ( closing ) {
                closing = false;
            }
            if ( timer ) {
                clearTimeout( timer );
                timer = null;
            }
            var $sections = $submenu.find( '.sections' );
            current = submenu;
            $( 'html' ).addClass( 'active' );
            el.addClass( 'delay active' );
            submenus.removeClass( 'delay active' ).css( 'height', 0 ).off( 'transitionend webkitTransitionEnd' );
            $submenu.addClass( 'delay active' ).css( 'height', 0 ).off( 'transitionend webkitTransitionEnd' );
            requestAnimationFrame( function() {
                $submenu.css( 'height', $sections.outerHeight( true ) + 'px' );
                $submenu.one( 'transitionend webkitTransitionEnd', function( e ) {
                    if ( e.originalEvent.propertyName !== 'height' ) {
                        return;
                    }
                    if ( closing || ! $submenu.hasClass( 'active' ) ) {
                        return;
                    }
                    $submenu.css( 'height', 'auto' );
                });
            });
        }
        function closeSubmenu( lock, callback ) {
            if ( closing ) {
                return;
            }
            var $submenu = el.find( '.submenu.active' );
            if ( ! $submenu.length ) {
                current = '';
                $( 'html' ).removeClass( 'active' );
                el.removeClass( 'active delay' );
                submenus.removeClass( 'delay active' ).css( 'height', 0 ).off( 'transitionend webkitTransitionEnd' );
                if ( typeof callback === 'function' ) {
                    callback();
                }
                return;
            }
            if ( timer ) {
                clearTimeout( timer );
                timer = null;
            }
            closing = true;
            if ( lock ) {
                locked = true;
                unlockOnMove();
            }
            var $sections = $submenu.find( '.sections' );
            current = '';
            $submenu.off( 'transitionend webkitTransitionEnd' );
            $submenu.removeClass( 'active' );
            el.removeClass( 'active' );
            requestAnimationFrame( function() {
                $submenu.css( 'height', $sections.outerHeight( true ) + 'px' );
                $submenu[ 0 ].offsetHeight;
                $submenu.css( 'height', '0px' );
            });
            timer = setTimeout( function() {
                $( 'html' ).removeClass( 'active' );
                el.removeClass( 'delay' );
                submenus.removeClass( 'delay active' ).css( 'height', 0 ).off( 'transitionend webkitTransitionEnd' );
                timer = null;
                closing = false;
                if ( typeof callback === 'function' ) {
                    callback();
                }
            }, 550 );
        }
        $( 'header [data-link]' ).on( 'mouseenter', function() {
            var submenu = $( this ).data( 'link' );
            if ( submenu === 'Localisation' || submenu === 'Search' ) {
                return;
            }
            if ( submenu === 'Sell B&O' || submenu === 'Sale' ) {
                closeSubmenu( true );
                return;
            }
            if ( prevent ) {
                return;
            }
            if ( ! $( '[data-submenu="' + submenu + '"]' ).length ) {
                closeSubmenu( true );
                return;
            }
            openSubmenu( submenu );
        });
        $( 'header a, header [data-link]' ).on( 'click', function() {
            sessionStorage.setItem( 'prevent', '1' );
        });
        $( '[data-link="Localisation"], [data-link="Search"]' ).on( 'click', function( e ) {
            e.preventDefault();
            var submenu = $( this ).data( 'link' );
            var $target = $( '[data-submenu="' + submenu + '"]' );
            if ( ! $target.length ) {
                closeSubmenu( true );
                return;
            }
            if ( current === submenu && $target.hasClass( 'active' ) ) {
                closeSubmenu( true );
                return;
            }
            function openTarget() {
                overlay = submenu;
                setTimeout( function() {
                    overlay = '';
                }, 200 );
                openSubmenu( submenu );
            }
            if ( isMenuOpen() ) {
                closeMenu( openTarget );
                return;
            }
            openTarget();
        });
        el.on( 'mouseenter', '.submenu ~ .overlay', function() {
            if ( overlay && current === overlay ) {
                return;
            }
            closeSubmenu( false );
        });
        $( 'header .content .sections .section.three .blocks .block .icons .icon[data-icon="1"]' ).click(function() {
            if ( $( '.submenus .submenu.active' ).length ) {
                closeSubmenu( true, function() {
                    openMenu();
                });
                return;
            }
            if ( isMenuOpen() ) {
                closeMenu();
                return;
            }
            openMenu();
        });
    })();

    let swiperGlobalThree = null;
    let swiperProductOne = null;
    let swiperProductTwo = null;

    $(function() {

        const swiperGlobalOne = new Swiper( '.announcements .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            loop: true,
            centeredSlides: true,
            speed: 1375,
            spaceBetween: 0,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            }
        });

        const swiperGlobalTwo = new Swiper( '.menu .slider.one', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            slidesPerGroup: 1,
            spaceBetween: 0,
            loop: false,
            speed: 750,
            spaceBetween: 12,
            allowTouchMove: false
        });

        swiperGlobalThree = new Swiper( '.menu .slider.two', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            loop: true,
            centeredSlides: true,
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    speed: 1000
                },
                900: {
                    spaceBetween: 15,
                    speed: 1375
                }
            }
        });

        const reviewsSlides = document.querySelector( '.reviews .slider .slides' );
        if ( reviewsSlides ) {
            const reviews = Array.from( reviewsSlides.querySelectorAll( '.slide[data-date]' ) );
            reviews.sort( ( a, b ) => {
                return Number( b.dataset.date ) - Number( a.dataset.date );
            });
            reviews.forEach( ( review ) => {
                reviewsSlides.appendChild( review );
            });
        }

        const swiperGlobalFour = new Swiper( '.reviews .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: true,
            speed: 750,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.reviews .navigation .buttons .button.one',
                nextEl: '.reviews .navigation .buttons .button.two',
            },
            pagination: {
                bulletClass: 'icon',
                bulletActiveClass: 'active',
                el: '.reviews .pagination .icons',
                dynamicBullets: true,
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                    speed: 625
                },
                600: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 625
                },
                900: {
                    spaceBetween: 15,
                    slidesPerView: 3,
                    speed: 750
                },
                1375: {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    speed: 750
                }
            }
        });

        const swiperHomeThree = new Swiper( '.home .banner .slider.three', {
            containerModifierClass: 'slider-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoplay: false,
            loop: false,
            watchOverflow: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            breakpoints: {
                0: {
                    spaceBetween: 30,
                    speed: 1000,
                    slidesPerView: 2,
                },
                900: {
                    spaceBetween: 35,
                    speed: 1375,
                    slidesPerView: 5,
                }
            }
        });

        const swiperHomeOne = new Swiper( '.home .banner .slider.one', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            loop: true,
            centeredSlides: true,
            spaceBetween: 25,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                waitForTransition: true,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                0: {
                    speed: 1000,
                },
                900: {
                    speed: 1375,
                }
            },
            thumbs: {
                swiper: swiperHomeThree
            }
        });

        const swiperHomeTwo = new Swiper( '.home .banner .slider.two', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            loop: true,
            centeredSlides: true,
            spaceBetween: 25,
            autoplay: false,
            breakpoints: {
                0: {
                    speed: 1000,
                },
                900: {
                    speed: 1375,
                }
            }
        });

        const swiperHomeFour = new Swiper( '.home .introduction .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            autoHeight: true,
            slidesPerGroup: 1,
            spaceBetween: 50,
            loop: false,
            centeredSlides: true,
            speed: 1000,
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.home .introduction .navigation .buttons .button.one',
                nextEl: '.home .introduction .navigation .buttons .button.two'
            }
        });

        function destroyBanner() {
            if ( swiperProductOne ) {
                swiperProductOne.destroy( true, true );
                swiperProductOne = null;
            }
            if ( swiperProductTwo ) {
                swiperProductTwo.destroy( true, true );
                swiperProductTwo = null;
            }
        }

        function initProductBanner() {
            const productClass = document.querySelector( '.product' );
            if ( ! productClass ) {
                return;
            }

            destroyBanner();

            swiperProductTwo = new Swiper( '.product .banner .slider[data-slider="2"]', {
                containerModifierClass: 'slider-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                loop: false,
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                autoplay: false,
                breakpoints: {
                    0: {
                        direction: 'horizontal',
                        spaceBetween: 6,
                        speed: 625,
                        slidesPerView: 3,
                    },
                    900: {
                        direction: 'vertical',
                        spaceBetween: 6,
                        speed: 750,
                        slidesPerView: 4,
                    }
                }
            });

            swiperProductOne = new Swiper( '.product .banner .slider[data-slider="1"]', {
                containerModifierClass: 'slide-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                autoHeight: true,
                loop: false,
                centeredSlides: true,
                spaceBetween: 6,
                autoplay: false,
                navigation: {
                    disabledClass: 'disabled',
                    prevEl: '.product .banner .navigation .buttons .button.circle[data-action="1"]',
                    nextEl: '.product .banner .navigation .buttons .button.circle[data-action="2"]'
                },
                zoom: {
                    minRatio: 1,
                    maxRatio: 3,
                    containerClass: 'block',
                    zoomedSlideClass: 'magnify'
                },
                breakpoints: {
                    0: {
                        speed: 750,
                    },
                    900: {
                        speed: 1000,
                    }
                },
                thumbs: {
                    swiper: swiperProductTwo
                }
            });

            let scale = 1;

            function setZoomStep( nextScale ) {
                const targetScale = Math.max( 1, Math.min( nextScale, 3 ) );
                scale = targetScale;
                swiperProductOne.zoom.out();
                requestAnimationFrame( () => {
                    const slide = swiperProductOne.slides[ swiperProductOne.activeIndex ];
                    if ( ! slide ) {
                        return;
                    }
                    const wrap = slide.querySelector( '.product .overview .content .sections .banner .content .sections .section.two .blocks .block .sliders .blocks .block .blocks .block .slider .slides .slide .blocks .block[data-block="1BBA"]' );
                    if ( wrap ) {
                        wrap.style.transitionDuration = '300ms';
                        wrap.style.transform = 'translate3d( 0px, 0px, 0px )';
                    }
                    if ( targetScale > 1 ) {
                        requestAnimationFrame( () => {
                            swiperProductOne.zoom.in( targetScale );
                        });
                    }
                });
            }

            const zoomOut = productClass.querySelector( '.banner .zoom .buttons .button.circle[data-action="1"]' );
            const zoomIn = productClass.querySelector( '.banner .zoom .buttons .button.circle[data-action="2"]' );
            const video = productClass.querySelector( '.overview .content .sections .banner .content .sections .section.two .blocks .block .video .buttons .button.small' );

            if ( zoomOut ) {
                zoomOut.onclick = function() {
                    setZoomStep( scale - 1 );
                };
            }

            if ( zoomIn ) {
                zoomIn.onclick = function() {
                    setZoomStep( scale + 1 );
                };
            }

            swiperProductOne.on( 'zoomChange', ( swiper, newScale ) => {
                scale = newScale;
            });

            if ( video ) {
                video.onclick = function() {
                    swiperProductOne.slideTo( swiperProductOne.slides.length - 1 );
                };
            }
        }

        window.initProductBanner = initProductBanner;
        window.destroyBanner = destroyBanner;

        initProductBanner();

        const swiperProductThree = new Swiper( '.product .form .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 750,
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.product .form .navigation .buttons .button.circle[data-action="1"]',
                nextEl: '.product .form .navigation .buttons .button.circle[data-action="2"]'
            },
            breakpoints: {
                0: {
                    spaceBetween: 5,
                    slidesPerView: 2,
                    speed: 625
                },
                900: {
                    spaceBetween: 5,
                    slidesPerView: 2,
                    speed: 750
                }
            }
        });

        const swiperProductFour = new Swiper( '.product .products .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.product .products .navigation .buttons .button[data-action="1"]',
                nextEl: '.product .products .navigation .buttons .button[data-action="2"]'
            },
            breakpoints: {
                0: {
                    spaceBetween: 5,
                    slidesPerView: 2,
                    speed: 625
                },
                600: {
                    spaceBetween: 5,
                    slidesPerView: 3,
                    speed: 625
                },
                900: {
                    spaceBetween: 5,
                    slidesPerView: 4,
                    speed: 750
                },
                1250: {
                    spaceBetween: 5,
                    slidesPerView: 5,
                    speed: 750
                }
            }
        });

        const menu = document.querySelector( '.menu' );
        const menuSlide = menu.querySelector( '.slide[data-slide="1"]' );
        const submenuSlide = menu.querySelector( '.slide[data-slide="2"]' );
        const submenuLinks = submenuSlide.querySelector( '[data-links] ul' );
        const close = submenuSlide.querySelector( '.close' );
        const menuImage = menu.querySelector( '.content .sections .section.two .blocks .block .image' );
        const submenuData = JSON.parse( document.getElementById( 'submenus' ).textContent );
        const escapeHtml = ( value ) => {
            return String( value )
                .replaceAll( '&', '&amp;' )
                .replaceAll( '<', '&lt;' )
                .replaceAll( '>', '&gt;' )
                .replaceAll( '"', '&quot;' )
                .replaceAll( "'", '&#039;' );
        };
        const renderSubmenu = ( key ) => {
            const submenu = submenuData[ key ] || {};
            const items = submenu.links || [];
            submenuLinks.innerHTML = items.map( ( item ) => {
                const label = escapeHtml( item.label );
                const href = escapeHtml( item.href || '#' );
                return `
                    <li>
                        <a href="${ href }">${ label }</a>
                    </li>
                `;
            }).join( '' );
            requestAnimationFrame( () => {
                swiperGlobalTwo.updateAutoHeight( 300 );
            });
        };
        const fadeDuration = 600;
        const fadeDelay = 0;
        let MenuImage = null;
        let pendingMenuImage = null;
        let fade = null;
        const startFade = () => {
            if ( ! menuImage ) return;
            window.clearTimeout( fade );
            menuImage.classList.add( 'active' );
        };
        const commitMenuImage = ( nextKey ) => {
            if ( ! menuImage ) return;
            if ( nextKey === MenuImage ) {
                requestAnimationFrame( () => {
                    menuImage.classList.remove( 'active' );
                });
                return;
            }
            const src = submenuData[ nextKey ]?.image;
            if ( ! src ) {
                requestAnimationFrame( () => {
                    menuImage.classList.remove( 'active' );
                });
                return;
            }
            window.clearTimeout( fade );
            fade = window.setTimeout( () => {
                menuImage.style.backgroundImage = `url("${ String( src ).replaceAll( '"', '%22' ) }")`;
                requestAnimationFrame( () => {
                    menuImage.classList.remove( 'active' );
                });
                MenuImage = nextKey;
            }, fadeDelay );
        };
        const defaultMenuImage = 'Speakers';
        const initMenuImage = () => {
            if ( ! menuImage ) return;
            const src = submenuData[ defaultMenuImage ]?.image;
            if ( ! src ) return;
            menuImage.style.backgroundImage = `url("${ String( src ).replaceAll( '"', '%22' ) }")`;
            MenuImage = defaultMenuImage;
        };
        menuSlide.querySelectorAll( '[data-link]' ).forEach( ( li ) => {
            li.addEventListener( 'click', ( e ) => {
                const key = li.getAttribute( 'data-link' );
                if ( key === 'Sell B&O' || key === 'Sale' ) {
                    return;
                }
                e.preventDefault();
                pendingMenuImage = key;
                renderSubmenu( key );
                swiperGlobalTwo.slideTo( 1 );
            });
        });
        close.addEventListener( 'click', ( e ) => {
            e.preventDefault();
            swiperGlobalTwo.slideTo( 0 );
        });
        swiperGlobalTwo.on( 'slideChangeTransitionStart', () => {
            startFade();
        });
        swiperGlobalTwo.on( 'slideChangeTransitionEnd', () => {
            const index = swiperGlobalTwo.activeIndex;
            const nextKey = index === 0 ? defaultMenuImage : ( pendingMenuImage || MenuImage || defaultMenuImage );
            commitMenuImage( nextKey );
        });
        initMenuImage();

        swiperHomeOne.controller.control = [ swiperHomeTwo, swiperHomeThree ];
        swiperHomeTwo.controller.control = swiperHomeOne;
        const resetAutoplay = () => {
            swiperHomeOne.autoplay.stop();
            swiperHomeOne.autoplay.start();
        };
        [ swiperHomeOne, swiperHomeTwo, swiperHomeThree ].forEach( sw => {
            sw.on( 'touchEnd', resetAutoplay );
        });
        swiperHomeThree.on( 'click', resetAutoplay );
        swiperHomeOne.on( 'slideChangeTransitionEnd', resetAutoplay );
        let boundMode = null;
        const bindControllers = () => {
            const mobile = window.matchMedia( '(max-width: 900px)' ).matches;
            const nextMode = mobile ? 'mobile' : 'desktop';
            if ( nextMode === boundMode ) return;
            swiperHomeOne.controller.control = null;
            if ( mobile ) {
                swiperHomeOne.controller.control = [ swiperHomeTwo, swiperHomeThree ];
            } else {
                swiperHomeOne.controller.control = swiperHomeTwo;
            }
            boundMode = nextMode;
        };
        bindControllers();
        const mql = window.matchMedia( '(max-width: 900px)' );
        if ( mql.addEventListener ) {
            mql.addEventListener( 'change', bindControllers );
        } else if ( mql.addListener ) {
            mql.addListener( bindControllers );
        }
        const removeInitialAutoplay = swiper => {
            [ 0, 1, 2 ].forEach( i => swiper.slides[i]?.removeAttribute( 'data-swiper-autoplay' ) );
        };
        let removedThumbDelays = false;
        const removeAutoplayFromThree = () => {
            if ( removedThumbDelays ) return;
            const slides = swiperHomeThree.slides;
            for ( let i = 0; i < Math.min( 3, slides.length ); i++ ) {
                slides[i]?.removeAttribute( 'data-swiper-autoplay' );
            }
            removedThumbDelays = true;
        };
        swiperHomeOne.on( 'slideChangeTransitionEnd', () => removeInitialAutoplay( swiperHomeOne ) );
        swiperHomeTwo.on( 'slideChangeTransitionEnd', () => removeInitialAutoplay( swiperHomeTwo ) );
        swiperHomeOne.on( 'init', removeAutoplayFromThree );
        swiperHomeOne.on( 'slideChangeTransitionEnd', () => {
            if ( [ 0, 1, 2 ].includes( swiperHomeOne.realIndex ) ) removeAutoplayFromThree();
        });
        swiperGlobalOne.on( 'init', () => {
            swiperGlobalOne.slides[0]?.removeAttribute( 'data-swiper-autoplay' );
        });

    });

    document.addEventListener( 'DOMContentLoaded', function() {
        const blocks = document.querySelectorAll( '[data-visibility]' );
        const observer = new IntersectionObserver( ( entries, obs ) => {
            entries.forEach(entry => {
                if ( entry.isIntersecting ) {
                    entry.target.setAttribute( 'data-visibility', 'true' );
                    obs.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.25
        });
        blocks.forEach( block => {
            block.setAttribute( 'data-visibility', 'false' );
            observer.observe( block );
        });
    });

    document.addEventListener( 'cart:updated', function( event ) {
        var cart = event.detail.cart;
        document.querySelectorAll( '[data-number]' ).forEach( function( el ) {
            el.textContent = cart.item_count;
        });
    });

    document.addEventListener( 'DOMContentLoaded', function() {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        fetch( root + 'cart.js', {
            credentials: 'same-origin'
        })
            .then( function( response ) {
                return response.ok ? response.json() : null;
            })
            .then( function( cart ) {
                if ( ! cart ) {
                    return;
                }
                document.querySelectorAll( '[data-number]' ).forEach( function( el ) {
                    el.textContent = cart.item_count;
                });
            })
            .catch( function() {} );
    });

    $( document ).on( 'click', 'header [data-icon="2"]', function() {
        $( '.bag' ).addClass( 'delay' );
        setTimeout( function() {
            $( '.bag' ).addClass( 'active' );
        }, 100 );
    });

    $( document ).on( 'click', '.bag .close, .bag .overlay', function() {
        setTimeout( function() {
            $( '.bag' ).removeClass( 'delay' );
        }, 750 );
        $( '.bag' ).removeClass( 'active' );
    });

    document.querySelectorAll( '.input input, .textarea textarea, .select select' ).forEach( input => {
        input.addEventListener( 'focus', () => {
            input.parentElement.dataset.input = 'focus';
        });
        input.addEventListener( 'blur', () => {
            if ( input.value.trim() !== '' ) {
                input.parentElement.dataset.input = 'focus';
            } else {
                input.parentElement.dataset.input = '';
            }
        });
        if ( input.value.trim() !== '' && ! input.closest( '[data-submenu="Search"]' ) ) {
            input.parentElement.dataset.input = 'focus';
        }
    });

    document.addEventListener( 'DOMContentLoaded', () => {
        document.querySelectorAll( '[data-submenu="Search"] input' ).forEach( input => {
            input.value = '';
            input.parentElement.dataset.input = '';
        });
    });

    $( '.form .fields .fieldset .blocks .block .toggle' ).click(function() {
        const $wrapper = $( this ).closest( '.blocks' );
        const $input = $wrapper.find( '.input input' );
        if ( $input.attr( 'type' ) === 'password' ) {
            $input.attr( 'type', 'text' );
        } else {
            $input.attr( 'type', 'password' );
        }
        const $icons = $( this ).find( '.icons' );
        $icons.toggleClass( 'active' );
    });

    function checkBagScrollbar( el ) {
        const update = () => {
            el.classList.toggle( 'scroll', el.scrollHeight > el.clientHeight + 1 );
            el.classList.toggle( 'active', el.scrollTop > 0 );
        };
        update();
        el.addEventListener( 'scroll', update, {
            passive: true
        });
        window.addEventListener( 'resize', update );
        return {
            destroy: () => {
                el.removeEventListener( 'scroll', update );
                window.removeEventListener( 'resize', update );
            },
            update
        };
    }
    const section = '.bag .content .sections .section.two';
    const viewport = window.matchMedia( '(min-width: 750px)' );
    const bag = document.querySelector( '.bag' );
    let listener = [];
    let updaters = [];
    function runUpdates() {
        updaters.forEach( ( fn ) => fn() );
    }
    function toggleElement( e ) {
        listener.forEach( ( item ) => item.destroy() );
        listener = [];
        updaters = [];
        if ( e.matches ) {
            document.querySelectorAll( section ).forEach( ( el ) => {
                const item = checkBagScrollbar( el );
                listener.push( item );
                updaters.push( item.update );
            });
        }
    }
    viewport.addEventListener( 'change', toggleElement );
    toggleElement( viewport );
    if ( bag ) {
        const bagObserver = new MutationObserver( () => {
            if ( bag.classList.contains( 'delay' ) ) {
                requestAnimationFrame( runUpdates );
            }
        });
        bagObserver.observe( bag, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
    }

    $(function() {
        const intercom = document.querySelector( '.intercom' );
        const footer = document.querySelector( 'footer' );
        const observer = new IntersectionObserver(
        ( entries ) => {
            entries.forEach( ( entry ) => {
                intercom.style.opacity = entry.isIntersecting ? '0' : '1';
                intercom.style.pointerEvents = entry.isIntersecting ? 'none' : 'auto';
            });
        }, {
            root: null,
            threshold: 0
        });
        observer.observe( footer );
    });

    $( '.accordion .panels .panel .blocks .block[data-block="A"]' ).click(function() {
        const $el = $( '.accordion .panels .panel .blocks .block[data-block="A"]' );
        $el.not( this ).removeClass( 'active' );
        $el.not( this ).parent().find( '.block[data-block="B"]' ).css( 'height', '0' );
        $( this ).toggleClass( 'active' );
        const $content = $( this ).parent().find( '.block[data-block="B"]' );
        let height = '0';
        if ( $( this ).hasClass( 'active' ) ) {
            height = $content.prop( 'scrollHeight' ) + 'px';
        }
        $content.css( 'height', height );
    });

    $( '.accordion .panels .panel .blocks .block[data-block="A"].active' ).each(function() {
        const $content = $( this ).parent().find( '.block[data-block="B"]' );
        const height = $content.prop( 'scrollHeight' ) + 'px';
        $content.css( 'height', height );
    });

    $( document ).on( 'change', '.shop .collection .sort select', function() {
        const $select = $( this );
        const $sort = $select.closest( '.sort' );
        const $mirror = $sort.find( '.select .option' );
        const selectedText = $select.find( 'option:selected' ).text();
        $mirror.text( selectedText );
        const isMobile = document.documentElement.classList.contains( 'mobile' );
        const padding = isMobile ? 89 : 87;
        const width = $mirror.outerWidth() + padding;
        $select.css({
            width: width + 'px'
        });
    }).trigger( 'change' );

    $( '.shop .collection .filter' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '.shop .collection .content .sections .section.one' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '.shop .collection .content .sections .section.one' ).addClass( 'active' );
            });
        });
    });

    $( '.shop .collection .overlay, .shop .collection .filters .close' ).click( function() {
        $( 'body' ).removeClass( 'active' );
        $( '.shop .collection .content .sections .section.one' ).removeClass( 'active' );
        setTimeout( function() {
            $( '.shop .collection .content .sections .section.one' ).removeClass( 'delay' );
        }, 750 );
    });

    $( '.shop .description .content .sections .section.two .blocks .block .buttons .button.small' ).click( function() {
        $( '.shop .description .content .sections .section.two .blocks[data-blocks="1"]' ).toggleClass( 'active' );
    });

    $( '.product .overview .content .sections .banner .content .sections .section.two .blocks .block .sliders .blocks .block .blocks .block .slider[data-slider="1"]' ).click( function( event ) {
        const swiper = this.swiper;
        if ( swiper && swiper.allowClick === false ) {
            return;
        }
        const media = window.innerWidth < 900 ? 35 : 0;
        const offset = $( '.product .overview' ).offset().top - media;
        $( 'html, body' ).stop( true ).animate( {
            scrollTop: offset
        }, 200 );
        $( 'html' ).addClass( 'active' );
        $( 'html' ).addClass( 'focus' );
        $( '.product .overview' ).addClass( 'delay' );
        setTimeout( function() {
            $( '.product .overview' ).addClass( 'active' );
        }, 200 );
    });

    $( '.product .banner .close' ).click( function() {
        const media = window.innerWidth < 900 ? 80 : 65;
        const offset = $( '.product .overview' ).offset().top - media;
        $( 'html, body' ).stop( true ).animate( {
            scrollTop: offset
        }, 200, function() {
            $( 'html' ).removeClass( 'active' );
            $( 'html' ).removeClass( 'focus' );
            $( '.product .overview' ).removeClass( 'active' );
            setTimeout( function() {
                $( '.product .overview' ).removeClass( 'delay' );
            }, 600 );
        });
    });

    document.querySelectorAll( '.modal' ).forEach( el => {
        const classes = [ ...el.classList ];
        const modal = classes.find( c => c !== 'modal' && c !== 'shopify-section' );
        if ( modal ) {
            el.dataset.modal = modal.charAt( 0 ).toUpperCase() + modal.slice( 1 );
            el.classList.remove( modal );
        }
    });

    $( '[data-action="Finance"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Finance"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Finance"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Contents"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Contents"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Contents"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Images"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Images"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Images"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Condition"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Condition"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Condition"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Delivery"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Delivery"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Delivery"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Warranty"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Warranty"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Warranty"]' ).addClass( 'active' );
            });
        });
    });

    $( '[data-action="Returns"]' ).click( function() {
        $( 'body' ).addClass( 'active' );
        $( '[data-modal="Returns"]' ).addClass( 'delay' );
        requestAnimationFrame( function() {
            requestAnimationFrame( function() {
                $( '[data-modal="Returns"]' ).addClass( 'active' );
            });
        });
    });

    $( '.modal .overlay, .modal .close' ).click( function() {
        $( 'body' ).removeClass( 'active' );
        $( '[data-modal]' ).removeClass( 'active' );
        setTimeout( function() {
            $( '[data-modal]' ).removeClass( 'delay' );
        }, 750 );
    });
